import React from 'react'
import { useTranslation } from 'react-i18next'
import { IoIosArrowForward } from "react-icons/io";
import Accordion from '../../../Accordion';


const BaggageAllowance = () => {
  
  return (
    <section className='w-full my-20'>
      <div className="mobileS:w-full lg:w-[70%] mx-auto">
        <Accordion props={staticBaggage}/>
      </div>
    </section>
  )
}

export default BaggageAllowance


export const staticBaggage = [
  {
    title: "firstColTitleBaggage",
    columns: ["normColOne.0", "normColOne.1", "normColOne.2", "normColOne.3"]
  },
  {
    title: "secondColTitleBaggage",
    columns: ["normColTwo.0", "normColTwo.1", ""]
  },
  {
    title: "thirdColTitleBaggage",
    columns: ["normColThree.0", "normColThree.1", "normColThree.2", "normColThree.3", "normColThree.4"]
  }
]